import { useEffect, useState, useMemo } from 'react';
import { Button } from 'semantic-ui-react';
import Loading from '../../../components/Loading';
import CenterCell from '../../../components/table/CenterCell';
import BasicPaginatedTable from '../../../components/table/BasicPaginatedTable';
import Confirm from '../../../components/Confirm';
import AddKey from './AddKey';
import { getAPI, postAPI, deleteAPI } from '../../../libs/fetchAPI';

function APIKeys() {
	const [ loading, setLoading ]             = useState(true);
	const [ saving, setSaving ]               = useState(false);
	const [ show_confirm, setShowConfirm ]    = useState(false);
	const [ show_add_modal, setShowAddModal ] = useState(false);
	const [ keys, setKeys ]                   = useState([]);
	const [ api_key, setApiKey ]              = useState(false);
	const [ key_name, setKeyName ]            = useState();
	const [ delete_key_id, setDeleteKeyId ]   = useState();

	useEffect(() => {
		refetchKeys();
	}, []);

	function refetchKeys() {
		setLoading(true);

		getAPI(`/api_keys`)
			.then(({ data }) => {
				setKeys(data);
				setLoading(false);
			});
	}

	function handleCloseModal() {
		setShowAddModal(false);
		setApiKey(null);
		refetchKeys();
	}

	function handleAddKey() {
		setSaving(true);

		postAPI(`/api_keys`, {
			name : key_name,
		}).then(({ data }) => {
			setApiKey(data[0].api_key);
			setSaving(false);
		});
	}

	function updateKeyName(e) {
		setKeyName(e.target.value);
	}

	function handleDeleteKey() {
		setSaving(true);
		deleteAPI(`/api_keys/${delete_key_id}`)
			.then(() => {
				setSaving(false);
				setShowConfirm(false);
				refetchKeys();
			});
	}

	function handleDeleteClick(id) {
		setDeleteKeyId(id);
		setShowConfirm(true);
	}

	function handleNo() {
		setShowConfirm(false);
	}

	const columns = useMemo(() => [
		{
			Header   : `Name`,
			accessor : `name`,
		},
		{
			Header         : ``,
			accessor       : `id`,
			collapse       : true,
			disableFilters : true,
			Cell           : ({ cell }) => <CenterCell><Button negative onClick={() => handleDeleteClick(cell.value)}>Delete</Button></CenterCell>
		}
	], []);

	if(loading) {
		return <Loading />
	}

	return (
		<>
			<Confirm
				open={show_confirm}
				handleYes={handleDeleteKey}
				handleNo={handleNo}
				loading={saving}
				header_content="Delete API Key"
				body_content="Are you sure you want to delete this API key?"
			/>

			<Button
				positive
				onClick={() => setShowAddModal(true)}
			>
				Add Key
			</Button>

			<AddKey
				open={show_add_modal}
				saving={saving}
				handleClose={handleCloseModal}
				handleAddKey={handleAddKey}
				updateKeyName={updateKeyName}
				api_key={api_key}
			/>

			<BasicPaginatedTable
				columns={columns}
				data={keys}
				default_page_size="15"
				show_filters={false}
			/>
		</>
	);
}

export default APIKeys;
